// extracted by mini-css-extract-plugin
export default {"Bkgnd":"Panel_Bkgnd__fQSK-"};